// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import clsx from "clsx";
import { ColumnsType } from "antd/es/table";
import { Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";

// Local Imports
import FundService from "./fund.service";
import CustomSearch from "../../components/custom-search/custom-search";
import CustomTable from "../../components/custom-table/custom-table";
import CustomModal from "../../components/custom-modal/custom-modal";
import { CREATE_BREADCRUMB } from "../../store/actions";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import { text } from "stream/consumers";
import { formatNumber } from "src/utils/helper/functions";

const Funds: React.FC = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loadingState = useSelector((state: any) => state?.loading);
  const fundService = new FundService();
  const [viewModal, setViewModal] = useState<boolean>(false);
  const [fundListData, setFundListData] = useState<any[]>([]);
  // const [selectedFund, getSelectedFund] = useState<any>();

  useEffect(() => {
    fetchCompletedListData();
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Fund list",
            type: "link",
            link: "/funds",
          },
        ],
      },
    });
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (_, __, index: number) => <span>{index + 1}</span>,
    },
    {
      title: "Name En",
      dataIndex: "NAME",
      key: "NAME",
      sorter: (a, b) => String(a?.NAME).localeCompare(String(b?.NAME)),
      fixed: "left",
      render: (text) => (
        <Link to="" onClick={() => setViewModal(true)}>
          {text}
        </Link>
      ),
    },
    {
      title: "Name Ar",
      dataIndex: "NAME_ARA",
      key: "NAME_ARA",
      sorter: (a, b) => String(a?.NAME_ARA).localeCompare(String(b?.NAME_ARA)),
      render: (text) => (
        <Link to="" onClick={() => setViewModal(true)}>
          {text}
        </Link>
      ),
    },
    {
      title: "Minimum amount",
      dataIndex: "MIN_SUBS_AMT",
      key: "MIN_SUBS_AMT",
      sorter: (a, b) => a.MIN_SUBS_AMT - b.MIN_SUBS_AMT,
      render: (text) => <span>{formatNumber(text)}</span>,
    },
    {
      title: "Currency",
      dataIndex: "INV_CCY",
      key: "INV_CCY",
      sorter: (a, b) => String(a?.INV_CCY).localeCompare(String(b?.INV_CCY)),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => String(a?.isActive).localeCompare(String(b?.isActive)),
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "Inactive",
          value: false,
        },
      ],
      onFilter: (value, record) => record.isActive === value,
      render: (_, record) => (
        <span
          className={clsx(
            "rounded bg-gray-600 text-xs font-medium w-fit py-2 px-3",
            record?.isActive
              ? "bg-gray-600 text-green-500"
              : "bg-pink-200 text-pink-300"
          )}
        >
          {record?.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
      sorter: (a, b) => a.order - b.order,
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-3">
          <ReactSVG
            src={"/images/edit.svg"}
            onClick={() => navigate(`/funds/edit-fund/${record?.id}`)}
          />
        </div>
      ),
    },
  ];

  const fetchCompletedListData = async (): Promise<void> => {
    const data = await fundService.getFundListData();

    if (data !== undefined) {
      setFundListData(data);
    }
  };

  return (
    <div className="completed-table">
      <BreadcrumbComponent />
      <div className="flex items-center justify-between rounded-lg bg-white py-[10px] px-5">
        <p className=" text-black-300 text-base font-bold">
          {!loadingState ? fundListData?.length : ""} Funds
        </p>
        <div className="images flex items-center">
          {/* <CustomSearch />
          <Tooltip placement="topLeft" title="Columns settings">
            <img src={"/images/grid.svg"} alt="grid" />
          </Tooltip> */}
        </div>
      </div>
      {fundListData?.length ? (
        <CustomTable columns={columns} data={fundListData} showPagination={false} />
      ) : !loadingState ? (
        <div className="flex flex-col gap-3 w-full items-center justify-center mt-9">
          <img
            className="w-[40px] h-[40px]"
            src="/images/no-items.svg"
            alt="no data kamco"
          />
          <p className="text-lg text-gray-500 font-medium">
            There are no items in this list
          </p>
        </div>
      ) : (
        ""
      )}

    </div>
  );
};

export default Funds;
